import React from "react";

const Button = ({
  handleClick,
  children,
  type = "button",
  buttonRef,
  className,
  additionalclasses,
  ...rest
}) => {
  if (
    process.env.NODE_ENV !== "production" &&
    children.type?.name !== "ButtonContent"
  ) {
    throw new Error(
      "Button component only accepts ButtonContent component as children"
    );
  }

  return (
    <button
      onClick={handleClick}
      type={type}
      ref={buttonRef}
      className={`${className} ${additionalclasses || ""}`}
      {...rest}
    >
      {children}
    </button>
  );
};

Button.defaultProps = {
  className: `text-grey-50 dark:text-grey-dark-50 bg-grey-500 dark:bg-grey-dark-500 disabled:bg-grey-200 dark:disabled:bg-grey-dark-200 poppins-medium text-center content-center rounded-[8px] !px-[17px] h-[43px] text-[14px] w-full !flex justify-center items-center gap-[5px] disabled:cursor-not-allowed mt-4 max-w-[400px]`,
};

export default Button;
